import { DDSToast } from "@web-monorepo/dds";
import { Trans } from "@web-monorepo/i18n/macro";

/** What `showTranslationErrorNotification` shows. */
export const TranslationErrorToast = () => (
  <DDSToast variant="error">
    <strong>
      <Trans>Translations didn't load.</Trans>
    </strong>{" "}
    <Trans>Some text is showing in English. Refresh the page to try again.</Trans>
  </DDSToast>
);
